// Appointments
const AppointmentsList = () => import('@/views/appointments/AppointmentsList.vue')
const AppointmentForm = () => import('@/views/appointments/AppointmentForm.vue')
const AppointmentView = () => import('@/views/appointments/AppointmentView.vue')

export const appointmentRoutes = [
  {
    path: '/patients/:patientId/appointments',
    name: 'PatientAppointments',
    component: AppointmentsList,
    meta: {
      requireAuth: true,
      title: 'Patient Appointments'
    }
  },
  {
    path: '/patients/:patientId/appointments/new',
    name: 'NewPatientAppointment',
    component: AppointmentForm,
    meta: {
      requireAuth: true,
      title: 'New Patient Appointment'
    }
  },
  {
    path: '/patients/:patientId/appointments/:appointmentId',
    name: 'ViewPatientAppointment',
    component: AppointmentView,
    meta: {
      requireAuth: true,
      title: 'View Patient Appointment'
    }
  },
  {
    path: '/patients/:patientId/appointments/:appointmentId/edit',
    name: 'EditPatientAppointment',
    component: AppointmentForm,
    meta: {
      requireAuth: true,
      title: 'Edit Patient Appointment'
    }
  }
]
